import { RenderLeafProps } from 'slate-react'

type TStyleColor = {
  color?: string
  backgroundColor?: string
  fontSize?: number
}

export const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>
  }

  if (leaf.italic) {
    children = <em>{children}</em>
  }

  if (leaf.underline) {
    children = <u>{children}</u>
  }

  if (leaf.strikethrough) {
    children = <del>{children}</del>
  }

  if (leaf.superscript) {
    children = <sup>{children}</sup>
  }

  if (leaf.subscript) {
    children = <sub>{children}</sub>
  }

  if (leaf.color || leaf.backgroundColor || leaf.fontSize) {
    const style: TStyleColor = {}
    if (leaf.color) {
      style.color = `${leaf.color}`
    }
    if (leaf.backgroundColor) {
      style.backgroundColor = `${leaf.backgroundColor}`
    }
    if (leaf.fontSize) {
      // number → React renders it as px
      style.fontSize = leaf.fontSize
    }
    children = <span style={style}>{children}</span>
  }

  return <span {...attributes}>{children}</span>
}
